import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { PrintNode_ModuleContextService } from './PrintNode.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class PrintNode_home_ComponentContextService {
  private readonly moduleContext: PrintNode_ModuleContextService;

  constructor(moduleContext: PrintNode_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'home',
      type: ComponentType.form
    }
  }
}